import axios from "axios";
import { del, get, post } from "./methods";

export const uploadExcelFile = async (data) => {
  try {
    const response = await post( `/bulk-uploads`,data, );
    return response;
  } catch (error) {
    console.error("upload failed:", error);
    throw error;
  }
};

export const getUploadedExcelsList = async (perpage = 10, page = 1, status = "", types = "", dateAdded = "",search="") => {
  try {
    const response = await get(
      `/bulk-uploads?perpage=${perpage}&page=${page}&status=${status}&types=${types}&dateAdded=${dateAdded}&search=${search}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching uploaded excels:", error);
    throw error;
  }
};
export const getBulkUploadFilter = async () => {
  try {
    const response = await get(`/bulk-uploads/filter`);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getExcelProgressById = async (excelId) => {
  try {
    const response = await get(
      `/bulk-uploads/${excelId}/progress`,
      
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};


export const getExcelTasksById = async (excelId) => {
  try {
    const response = await get(
      `/bulk-uploads/${excelId}/tasks`,

    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const cancelBulkUpload = async (excelId) => {
  try {
    const response = await post(`/bulk-uploads/${excelId}/cancel`);
    return response;
  } catch (error) {
    console.error("Error cancelling bulk upload:", error);
    throw error;
  }
};

export const getGroupedFailures = async () => {
  try {
    const response = await get(`/bulk-uploads/failures/grouped`);
    return response;
  } catch (error) {
    console.error("Error fetching grouped failures:", error);
    throw error;
  }
};

export const retryFailuresByCause = async (cause) => {
  try {
    const response = await post(`/bulk-uploads/failures/retry`, { cause });
    return response;
  } catch (error) {
    console.error("Error retrying failures by cause:", error);
    throw error;
  }
};

export const getMedia = async ({mediaType ,perpage = 20, page = 1, search = "" }) => {
  try {
    const response = await get(
      `/media?media_type=${mediaType}&perpage=${perpage}&page=${page}&search=${search}`,
     
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postZip = async (data) => {
  try {
    const response = await post(`/zip-uploads`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const postAws = async (data) => {
  try {
    const response = await post(`/aws-sync`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

// export const getAwsBucketList = async (data) => {
//   try {
//     const response = await get(`/aws-sync`,
//       data,
//     );
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };
export const getAwsBucketList = async () => {
  try {
    const response = await get(`/aws-sync`);
    return response; 
  } catch (error) {
    throw error;
  }
};

export const postMRSSFeed = async (data) => {
  try {
    const response = await post(`/mrss-feed`, data,);
    return response;
  } catch (error) {
    throw error;
  }
};
export const uploadSeriesFile = async (data) => {
  try {
    const response = await post(`/bulk-series-imports`, data);
    return response;
  } catch (error) {
    console.error("upload failed:", error);
    throw error;
  }
};
export const getSeriesImportProgress = async (id) => {
  try {
    const response = await get(`/bulk-series-imports/${id}/progress`);
    return response;
  } catch (error) {
    console.error("fetch progress failed:", error);
    throw error;
  }
};
export const getSeriesImportTasks = async (id, params = {}) => {
  try {
    const response = await get(`/bulk-series-imports/${id}/tasks`, { params });
    return response;
  } catch (error) {
    console.error("fetch tasks failed:", error);
    throw error;
  }
};
// Token is attached automatically by axiosInstance — no need to pass it here.
export const bunnyApi = async (payload) => {
  try {
    const response = await post(`/bunny-stream`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating bunny stream config:", error);
    throw error;
  }
};

// Saved Bunny connections (no secrets — API key/password stay server-side).
export const getBunnyConnections = async () => {
  try {
    const response = await get(`/bunny-stream`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bunny connections:", error);
    throw error;
  }
};

// Re-run sync for a saved connection. Only the id is sent; the server uses the
// stored credentials, so nothing sensitive is transmitted from the browser.
export const syncBunnyConnection = async (id) => {
  try {
    const response = await post(`/bunny-stream/${id}/sync`);
    return response.data;
  } catch (error) {
    console.error("Error syncing bunny connection:", error);
    throw error;
  }
};